import { E as EmblaCarousel } from './embla-carousel.esm-CCUHK2kO.js';
import { a as addScrollBarListener } from './scrollbar-DHAl7Frv.js';

const STACKED_MEDIA_QUERY = '(width < 48rem)';

class USPSlider extends HTMLElement {
  /** @type {import('embla-carousel').EmblaCarouselType} */
  #embla;

  connectedCallback() {
    const breakpoints = { '(min-width: 80rem)': { active: false } };

    if (this.hasAttribute('data-stack-on-mobile'))
      breakpoints[STACKED_MEDIA_QUERY] = { active: false };

    this.#embla = EmblaCarousel(this.querySelector('.embla__viewport'), {
      align: 'center',
      dragFree: true,
      direction: document.dir,
      slidesToScroll: 'auto',
      active: true,
      breakpoints,
    });

    addScrollBarListener(this.#embla, this.querySelector('.embla__scrollbar'));
  }
}

customElements.define('usps-slider', USPSlider);
